export default {
  nav: {
    features: "Imkoniyatlar",
    pricing: "Narx",
    integrations: "Integratsiyalar",
    how: "Qanday ishlaydi",
    cta: "Bogʻlanish",
    download: "Yuklab olish",
    apps: "Ilovalar",
    menu: "Menyu",
    primary_nav: "Asosiy navigatsiya",
  },
  hero: {
    title_1: "Bitta menyu, bitta ombor —",
    title_2: "butun muassasa",
    title_3: "bitta sistemada",
    subtitle:
      "Kassa, oʻz yetkazib berish vitrinasi, QR menyu, ofitsiant ilovasi, ekranlar va ombor — barchasi bitta menyuda ishlaydi. Narxni bir marta oʻzgartirasiz — u hamma joyda oʻzgaradi. Oxirgi portsiyani sotdingiz — u shu zahoti vitrinadan yoʻqoladi.",
    cta_primary: "Bogʻlanish",
    cta_secondary: "Qanday ishlaydi",
    trust: "Birinchi oy bepul, toʻliq toʻplam · Sozlashni jamoamiz bajaradi",
    stat_venues_val: "20+",
    stat_venues: "muassasa",
    stat_country: "Oʻzbekiston",
    stat_payments: "Click / Payme / Rahmat",
    stat_trial_val: "1 oy",
    stat_trial: "bepul",
    dashboard: {
      url: "samly.uz/dashboard",
      home: "Asosiy",
      orders: "Buyurtmalar",
      menu: "Menyu",
      kitchen: "Oshxona",
      analytics: "Tahlil",
      staff: "Xodimlar",
      revenue_label: "Bugungi tushum",
      currency: "soʻm",
      orders_count: "Buyurtmalar",
      avg_check: "Oʻrtacha chek",
      avg_time: "Oʻrtacha vaqt",
      avg_time_val: "14 daq",
      paid: "Toʻlangan",
      waiting: "Kutilmoqda",
      order: "Buyurtma",
      table: "Stol",
    },
  },
  logos: {
    title: "Har qanday formatdagi muassasada ishlaydi",
    formats: {
      restaurants: "Restoranlar",
      cafes: "Qahvaxonalar",
      oshkhona: "Oshxona",
      fastfood: "Fastfud",
      chains: "Tarmoqlar",
    },
  },
  painpoints: {
    title: "Uchta sistema — va uchalasi boshqacha hisoblaydi",
    subtitle:
      "Kassa, Excel'dagi ombor va agregatordagi vitrina bir-birini bilmaydi. Buni mehmondan bilib olasiz.",
    before_label: "Samly'siz",
    after_label: "Samly bilan",
    before: [
      "Kassada narxni oshirdingiz — yetkazib berish vitrinasida eskisi qoldi",
      "Palov tugadi, lekin unga buyurtmalar kelishda davom etadi",
      "Ombor Excel'da, kassa alohida, yetkazib berish agregatorda",
      "Ofitsiant mehmonga oshxonada yoʻq taomni vada qiladi",
      "Bitta hisobot uchun uchta faylni qoʻlda solishtirish kerak",
    ],
    after: [
      "Narxni bir marta oʻzgartirasiz — u barcha savdo nuqtalarida oʻzgaradi",
      "Oxirgi portsiya sotildi — taom vitrinadan yoʻqoldi",
      "Ombor, kassa va yetkazib berish bir xil qoldiqni hisoblaydi",
      "Stop-list ofitsiant, oshxona va mehmonga bir vaqtda koʻrinadi",
      "Butun muassasa boʻyicha bitta hisobot — solishtirishga hech narsa yoʻq",
    ],
  },
  onemenu: {
    tag: "Qanday ishlaydi",
    title: "Bitta menyu. Bitta ombor. Oltita savdo nuqtasi.",
    subtitle: "Siz menyu va qoldiqni bitta joyda yuritasiz. Qolganini Samly oʻzi kuzatib boradi.",
    hub_title: "Bitta menyu",
    hub_sub: "bitta ombor",
    surfaces: {
      pos: "Kassa",
      storefront: "Oʻz yetkazib berish",
      qr: "QR menyu",
      waiter: "Ofitsiant",
      screens: "Ekranlar",
      warehouse: "Ombor",
    },
    moments: [
      {
        title: "Narxni bir marta oʻzgartiring",
        desc: "Yangi narx shu zahoti kassada, QR menyuda, yetkazib berish vitrinasida, ofitsiantda va ekranlarda. Hech narsani takrorlash kerak emas.",
      },
      {
        title: "Oxirgi portsiyani soting",
        desc: "Taom shu sekundda stop-listga tushadi: vitrinadan yoʻqoladi, mehmon uni koʻrmaydi, ofitsiant esa uni chek qila olmaydi.",
      },
      {
        title: "Ombor ingredientlarni hisoblaydi",
        desc: "Har bir taomning texnologik kartasi bor. Palov sotildi — omborlardan guruch, yogʻ va goʻsht chiqdi. Qoldiq haqiqiy, «taxminan» emas.",
      },
    ],
  },
  stats: {
    items: [
      { val: "20+", label: "muassasa", sub: "Samly'da ishlaydi" },
      { val: "1 oy", label: "bepul", sub: "toʻliq toʻplam, kartasiz" },
      { val: "9", label: "komponent", sub: "faqat oʻzingiznikiga toʻlaysiz" },
      { val: "−30%", label: "yillik toʻlovda", sub: "minimal muddat — 3 oy" },
    ],
  },
  features: {
    title: "Oltita savdo nuqtasi, ostida bitta menyu",
    subtitle: "Muassasangizga keragini yoqasiz. Qolganini sotib olmaysiz.",
    tabs: {
      pos: "Kassa",
      storefront: "Oʻz yetkazib berish",
      qr: "QR menyu",
      waiter: "Ofitsiant",
      kitchen: "Oshxona",
      warehouse: "Ombor",
    },
    mock: {
      hall: "Zal · 12 stol",
      st_free: "boʻsh",
      st_paid: "toʻlangan",
      st_waiting: "kutmoqda",
      st_ordered: "buyurtma",
      accept_payment: "Toʻlovni qabul qilish",
      pin: "PIN",
      my_tables: "Mening stollarim",
      online: "onlayn",
      guests: "mehmon",
      positions: "pozitsiya",
      cooking: "Tayyorlanmoqda",
      ready: "Tayyor",
      accepted: "Qabul qilindi",
      kitchen_station: "Oshxona · issiq sex",
      delivery: "Yetkazib berish",
      storefront_head: "Sizning vitrinangiz · Telegram",
      add_to_cart: "Savatga",
      sold_out: "Mavjud emas",
      checkout: "Buyurtma berish",
      warehouse_head: "Retsept boʻyicha hisobdan chiqarish",
      warehouse_sold: "1 palov sotildi",
      warehouse_left: "qoldi",
      stop_list: "Stop-list",
      table: "Stol",
      total: "Jami",
      currency: "soʻm",
      your_order: "Sizning buyurtmangiz",
      pay_click: "Click bilan toʻlash",
      pay_payme: "Payme bilan toʻlash",
      dishes: {
        plov: "Palov",
        lagman: "Lagʻmon",
        tea: "Choy",
        shashlik: "Shashlik",
        manti: "Manti",
        soup: "Shoʻrva",
        salad: "Salat",
      },
      units: { g: "g", kg: "kg", ml: "ml", l: "l" },
      ingredients: {
        rice: "Guruch",
        oil: "Yogʻ",
        meat: "Mol goʻshti",
        carrot: "Sabzi",
      },
    },
    pos: {
      title: "Haqiqiy qoldiqni biladigan kassa",
      points: [
        "Naqd, karta va QR — bitta oynada",
        "Qaytarish, chegirma va oʻchirish — faqat menejer PIN kodi bilan",
        "Smenalar va kassa tafovutlari nazoratda",
        "E-Kassa (OFD) — Oʻzbekiston qoidalari boʻyicha fiskallashtirish",
        "Internetsiz ishlaydi, keyin sinxronlanadi",
      ],
    },
    storefront: {
      title: "Oʻz vitrinangiz, agregatordagi rafcha emas",
      points: [
        "Telegram Mini App, sayt va mobil ilova",
        "Oʻz domeningiz — mehmon sizning brendingizni koʻradi",
        "Click, Payme va Rahmat orqali toʻlov",
        "Buyurtma toʻgʻridan-toʻgʻri kassaga va oshxonaga tushadi",
        "Oʻz buyurtmalaringiz uchun agregator komissiyasini toʻlamaysiz",
      ],
    },
    qr: {
      title: "Mehmon oʻz telefonidan buyurtma beradi",
      points: [
        "Stoldagi QR — menyu brauzerda ochiladi, ilovasiz",
        "Butun stol uchun umumiy savat",
        "Click, Payme va Rahmat orqali toʻlov",
        "Kassadagi menyu va qoldiqning oʻzi",
        "Mehmon buyurtma holatini koʻradi va qayta soʻramaydi",
      ],
    },
    waiter: {
      title: "Ofitsiant yoʻq narsani sotmaydi",
      points: [
        "Planshet yoki har qanday Android telefon",
        "Stop-list real vaqtda yangilanadi",
        "Taomga izohlar: piyozsiz, achchiqroq",
        "Stolga qoʻshimcha buyurtma — qaytadan yigʻish kerak emas",
        "Taom tayyor boʻlganda push xabar",
      ],
    },
    kitchen: {
      title: "Oshpaz qogʻozni emas, buyurtmani koʻradi",
      points: [
        "Sexlar boʻyicha avtomatik taqsimlash: issiq, sovuq, bar",
        "Texnologik kartadan olingan har bir taom uchun taymer",
        "Holatlar: «tayyorlanmoqda» → «tayyor» → ofitsiantga",
        "Har bir oshpaz boʻyicha tayyorlash vaqti tahlili",
        "Obunaga kiradi — alohida toʻlash kerak emas",
      ],
    },
    warehouse: {
      title: "Ombor portsiyani emas, ingredientni hisoblaydi",
      points: [
        "Har bir taom uchun texnologik karta",
        "Palov sotildi — guruch, yogʻ va goʻsht hisobdan chiqdi",
        "Har bir pozitsiya boʻyicha tannarx va marja",
        "Ingredient tugashi bilan stop-list oʻzi shakllanadi",
        "Oshxona bittadan koʻp boʻlsa — bir nechta ombor",
      ],
    },
  },
  integrations: {
    title: "Siz allaqachon ishlatayotgan narsalar bilan ishlaydi",
    subtitle: "Toʻlov, yetkazib berish, uskuna va fiskallashtirish — quti ochilishi bilan.",
    soon: "rejalarda",
    groups: {
      payment: {
        title: "Toʻlov",
        items: [
          { name: "Click", desc: "QR va onlayn toʻlov" },
          { name: "Payme", desc: "Onlayn toʻlov" },
          { name: "Rahmat", desc: "Onlayn toʻlov" },
          { name: "Uzum Pay", desc: "Ulashni rejalashtirganmiz", soon: true },
        ],
      },
      delivery: {
        title: "Yetkazib berish",
        items: [
          { name: "Oʻz vitrinasi", desc: "Telegram, sayt, ilova" },
          { name: "Yandex Eats", desc: "Buyurtmalar avtomatik keladi" },
          { name: "Uzum Tezkor", desc: "Ulashni rejalashtirganmiz", soon: true },
        ],
      },
      equipment: {
        title: "Uskuna",
        items: [
          { name: "ESC/POS", desc: "Har qanday chek printeri" },
          { name: "StarPRNT", desc: "Cheklarni avtomatik chiqarish" },
          { name: "Smart TV / Fire Stick", desc: "Menyu ekranlari uchun" },
        ],
      },
      local: {
        title: "Oʻzbekiston",
        items: [
          { name: "E-Kassa (OFD)", desc: "Fiskallashtirish va hisobot" },
          { name: "Android / iOS", desc: "Har qanday qurilma" },
          { name: "Open API", desc: "Oʻz integratsiyalaringiz, obunaga kiradi" },
        ],
      },
    },
  },
  dashboardPreview: {
    owner: {
      badge: "Egasi",
      title: "Barcha filiallar bitta ekranda",
      features: {
        revenue: "Barcha filiallar boʻyicha tushum real vaqtda",
        alert: "Smena tafovut bilan yopilsa — darhol xabar",
        reports: "Har bir smena boʻyicha hisobot — avtomatik",
      },
      cta: "Imkoniyatlarni koʻrish",
      mockup: {
        title: "3 filial · bugun",
        live: "live",
        revenue: "soʻm",
        week: "oʻtgan haftaga nisbatan",
        branches: {
          chilanzar: "Chilonzor",
          yunusabad: "Yunusobod",
          samarkand: "Samarqand",
        },
      },
    },
    qr: {
      badge: "QR menyu",
      title: "Mehmon oʻzi buyurtma beradi va toʻlaydi",
      features: {
        no_app: "Ilovasiz — kamerani toʻgʻrilash kifoya",
        payments: "Click, Payme va Rahmat — bir daqiqadan kamroq vaqtda",
        cart: "Butun stol uchun umumiy savat",
      },
      cta: "QR menyu qanday ishlaydi",
      slides: {
        menu: "Menyu va mavjudlik",
        dish: "Taom kartasi",
        cart: "Savat va toʻlov",
      },
    },
    monitors: {
      badge: "Ekranlar",
      title: "Ekranlar aynan shu menyuni koʻrsatadi",
      features: {
        playlist: "Video va rasm — jadval boʻyicha",
        offline: "Internetsiz ishlaydi — USB xotiradan",
        update: "Kontent telefondan bir necha sekundda oʻzgaradi",
      },
      cta: "Ekranlar haqida batafsil",
      mockup: {
        menu_day: "Kun menyusi",
        lunch: "Biznes-lanch",
        action: "AKSIYA −15%",
        items: {
          lagman: "Lagʻmon",
          plov: "Palov",
          shashlik: "Shashlik",
          manti: "Manti",
        },
      },
    },
  },
  components: {
    title: "Faqat ishlatganingiz uchun toʻlaysiz",
    subtitle: "Tariflar yoʻq. Narx — komponentlar yigʻindisi. Qolgan hammasi obunaga kiradi.",
    paid_title: "Obuna komponentlari",
    paid_note:
      "Narxlar bir oy uchun. Oʻz yetkazib berish, ofitsiant ilovasi, QR menyu va Yandex Eats har bir filialga olinadi.",
    free_title: "Obunaga kiradi — qoʻshimcha toʻlovsiz",
    free_badge: "Kiradi",
    per_month: "/oy",
    per_branch: "filialga",
    min_one: "minimum 1",
    cta: "Oʻz toʻplamingizni yigʻish",
    items: {
      branches: { name: "Filiallar", desc: "Har bir nuqta oʻz zali va ombori bilan" },
      employees: { name: "Xodimlar", desc: "Har bir odamga bitta hisob, egasi ham hisobda" },
      pos_devices: { name: "POS qurilmalar", desc: "Monoblok, planshet yoki telefondagi kassa" },
      online_orders: {
        name: "Oʻz yetkazib berish",
        desc: "Telegram Mini App, sayt va ilova — oʻz domeningizda",
      },
      waiter_app: {
        name: "Ofitsiant ilovasi",
        desc: "Planshet yoki telefondan buyurtma, jonli stop-list",
      },
      qr_menu: { name: "QR menyu", desc: "Mehmon telefonidan menyu va toʻlov" },
      yandex: { name: "Yandex Eats", desc: "Yandex Eats buyurtmalari avtomatik keladi" },
      monitors: { name: "Menyu ekranlari", desc: "Har qanday Smart TV'da raqamli menyu va promo" },
      warehouses: { name: "Omborlar", desc: "Texnologik kartalar boʻyicha ingredient hisobi" },
    },
    free_items: {
      kds: { name: "Oshxona (KDS)", desc: "Taymer va navbat bilan oshpaz ekrani" },
      manager_app: { name: "Menejer ilovasi", desc: "Telefondan zal rejasi va xodimlar" },
      loyalty_crm: { name: "Loyallik va CRM", desc: "Mehmonlar bazasi va loyallik dasturi" },
      ai_analytics: { name: "AI tahlil", desc: "Savdo boʻyicha prognoz va tavsiyalar" },
      kiosk: { name: "Oʻzini-oʻzi xizmat kioski", desc: "Mehmon buyurtmani oʻzi beradi" },
      open_api: { name: "Open API", desc: "Oʻz sistemalaringiz bilan integratsiya" },
      stop_list: {
        name: "Real vaqtdagi stop-list",
        desc: "Tugadi — barcha nuqtalarda darhol yashiriladi",
      },
      cash_shift: { name: "Smenalar va Z-hisobotlar", desc: "Ochish, yopish, tafovutlar" },
      order_management: { name: "Buyurtmalarni boshqarish", desc: "Yaratish, oʻzgartirish, bekor qilish" },
      basic_analytics: { name: "Tahlil", desc: "Tushum, oʻrtacha chek, top taomlar" },
      order_status: { name: "Buyurtma holati ekrani", desc: "Zaldagi mehmonlar uchun" },
      e_kassa: { name: "E-Kassa (OFD)", desc: "Oʻzbekiston qoidalari boʻyicha fiskallashtirish" },
      pin_protection: { name: "Qaytarishga PIN", desc: "Qaytarish faqat menejer tasdigʻi bilan" },
      floor_plan: { name: "Zal rejasi va stollar", desc: "Zalning vizual sxemasi" },
      owner_push: { name: "Egasiga push", desc: "Qoidabuzarliklar haqida xabarlar" },
      qr_generator: { name: "QR kod generatori", desc: "Stollar uchun — chop etish va eksport" },
      payment_types: { name: "Toʻlov turlari", desc: "Naqd, karta, QR" },
      receipt_printer: { name: "Chek chiqarish", desc: "ESC/POS, StarPRNT — har qanday uskuna" },
    },
  },
  pricing: {
    tag: "Narx",
    title: "Tariflar yoʻq. Oʻz toʻplamingizni yigʻing.",
    subtitle: "Narx — BHM'ga bogʻlangan komponentlar yigʻindisi. Minimal muddat — 3 oy.",
    from_label: "dan",
    per_month: "soʻm/oy",
    from_note: "12 oyga toʻlaganda minimal toʻplam uchun",
    term_title: "Toʻlov muddati",
    term_note: "minimum 3 oy",
    build_title: "Toʻplamni yigʻing",
    reset: "Tashlash",
    col_component: "Komponent",
    col_unit: "Birlik narxi",
    col_qty: "Soni",
    col_sum: "Summa/oy",
    brv_label: "BHM, soʻm",
    brv_unit: "BHM",
    brv_note:
      "1 BHM = {{value}} soʻm. Narxlar BHM'ga bogʻlangan: u oʻzgarsa, soʻmdagi summa avtomatik qayta hisoblanadi.",
    matrix_title: "Toʻplamingiz muddatlar boʻyicha",
    col_term: "Muddat",
    col_discount: "Chegirma",
    col_per_month: "Oyiga",
    col_total: "Jami",
    receipt_title: "HISOB",
    receipt_empty: "Toʻplam boʻsh",
    receipt_base: "Chegirmasiz oylik narx",
    receipt_full: "{{months}} oyga chegirmasiz",
    receipt_discount: "Muddat uchun chegirma",
    receipt_total_sub: "soʻm {{months}} oyga",
    receipt_per_month: "Chegirmali oylik narx",
    receipt_save: "Tejamkorlik",
    show_detail: "Hisobni koʻrsatish",
    hide_detail: "Hisobni yashirish",
    month_one: "oy",
    month_few: "oy",
    month_many: "oy",
    rules_title: "Qanday hisoblanadi",
    rules: [
      "Narx — komponentlar yigʻindisi. Tariflar yoʻq.",
      "Minimal xarid muddati — 3 oy.",
      "Muddat uchun chegirma: 3 oy −10%, 6 oy −20%, 12 oy −30%.",
      "Yakuniy summa 0,05 BHM gacha kamaytirilib yaxlitlanadi.",
      "Minimum: 1 filial, 1 xodim, 1 POS qurilma.",
      "Oʻz yetkazib berish, ofitsiant ilovasi, QR menyu va Yandex Eats — har bir filialga, filiallar sonidan oshmaydi.",
    ],
    notes_title: "Alohida toʻlanadi",
    notes: [
      "Onboarding va sozlash — bepul, jamoamiz kuchi bilan.",
      "Uskuna (monoblok, printer, ekranlar) alohida sotib olinadi. Bu bir martalik xarajat va summalar juda xilma-xil — zalingiz va budjetingizga mos tanlashda yordam beramiz.",
    ],
    cta: "Bogʻlanish",
    cta_note: "Birinchi oy bepul, toʻliq toʻplam. Keyin — minimal muddat 3 oy.",
  },
  faq: {
    tag: "Savollar",
    title: "Koʻp beriladigan savollar",
    items: [
      {
        q: "Narx qanday hisoblanadi?",
        a: "Tariflar yoʻq. Siz toʻqqizta komponentdan toʻplam yigʻasiz va narx — ularning yigʻindisi. Narxlar BHM'ga bogʻlangan, minimal xarid muddati — 3 oy, muddat uchun chegirma: 3 oy −10%, 6 oy −20%, 12 oy −30%. Minimal toʻplam — 1 filial, 1 xodim va 1 POS qurilma.",
      },
      {
        q: "Obunaga qoʻshimcha toʻlovsiz nima kiradi?",
        a: "Oshxona (KDS), menejer ilovasi, loyallik va CRM, AI tahlil, oʻzini-oʻzi xizmat kioski, Open API, stop-list, smenalar va Z-hisobotlar, zal rejasi, E-Kassa (OFD), qaytarishga PIN, egasiga push va chek chiqarish. Toʻlash faqat filiallar, xodimlar, POS qurilmalar, oʻz yetkazib berish, ofitsiant ilovasi, QR menyu, Yandex Eats, ekranlar va omborlar uchun kerak.",
      },
      {
        q: "BHM nima va narx nega unda?",
        a: "BHM — bazaviy hisoblash miqdori, Oʻzbekistonda koʻp hisob-kitoblar unga bogʻlangan. Hozir 1 BHM = 412 000 soʻm. Narxlarning BHM'da boʻlishi shuni bildiradi: biz narxnomani qoʻlda qayta yozmaymiz, BHM oʻzgarsa soʻmdagi summa avtomatik qayta hisoblanadi. Toʻlov esa soʻmda.",
      },
      {
        q: "Ombor haqiqatan portsiyani emas, ingredientni hisoblaydimi?",
        a: "Ha. Har bir taomning texnologik kartasi bor. Palov sotilganda omborlardan guruch, yogʻ va goʻsht siz koʻrsatgan miqdorda hisobdan chiqadi. Shu sababli qoldiq haqiqiy, tannarx oʻzi hisoblanadi, stop-list esa istalgan ingredient tugashi bilan avtomatik shakllanadi.",
      },
      {
        q: "Oʻz yetkazib berish qanday ishlaydi?",
        a: "Siz oʻz vitrinangizni olasiz: Telegram Mini App, sayt va mobil ilova, xohlasangiz oʻz domeningizda. Toʻlov — Click, Payme va Rahmat. Buyurtma bir xil menyu va bir xil qoldiq bilan toʻgʻridan-toʻgʻri kassaga va oshxonaga tushadi. Bunday buyurtmalar uchun agregator komissiyasini toʻlamaysiz. Kerak boʻlsa, Yandex Eats'ni ham ulash mumkin.",
      },
      {
        q: "Joriy etish qancha vaqt oladi?",
        a: "Bir haftagacha. Sozlashni jamoamiz bajaradi: menyuni koʻchiramiz, texnologik kartalarni kiritamiz, uskunani ulaymiz va xodimlarni oʻqitamiz. Onboarding bepul.",
      },
      {
        q: "Uskuna sotib olish kerakmi?",
        a: "Agar hali boʻlmasa — ha. Kassa uchun monoblok, chek printeri, oshxona va menyu uchun ekranlar alohida sotib olinadi. Bu bir martalik xarajat va summalar juda xilma-xil, shuning uchun uni obunaga qoʻshmaymiz. Zalingizga aynan nima kerakligini aytamiz va budjetga moslaymiz. Samly Android va iOS'da ishlaydi, shuning uchun bir qismini oddiy planshet bilan qoplash mumkin.",
      },
      {
        q: "Internetsiz ishlaydimi?",
        a: "Kassa va oshxona ekrani oflayn ishlaydi. Menyu ekranlari kontentni USB xotiradan koʻrsatishi mumkin. Internet qaytganda maʼlumotlar oʻzi sinxronlanadi — birorta buyurtma yoʻqolmaydi.",
      },
      {
        q: "Qaysi integratsiyalar hozir ishlaydi?",
        a: "Toʻlov — Click, Payme va Rahmat. Yetkazib berish — oʻz vitrinasi va Yandex Eats. Fiskallashtirish — E-Kassa (OFD). Uskuna — har qanday ESC/POS va StarPRNT printerlar. Uzum Pay va Uzum Tezkor'ni ulashni rejalashtirganmiz.",
      },
      {
        q: "Bepul oy nima beradi?",
        a: "Bir oy davomida komponentlarning toʻliq toʻplami, kartasiz va majburiyatsiz. Shundan keyin qolsangiz, 3 oylik minimal muddat amal qiladi.",
      },
      {
        q: "Oʻzbek tilida qoʻllab-quvvatlash bormi?",
        a: "Ha. Interfeys oʻzbek, rus va ingliz tillarida. Qoʻllab-quvvatlash oʻzbek va rus tillarida telefon va Telegram orqali javob beradi — yakshanbadan tashqari har kuni, 10:00 dan 22:00 gacha.",
      },
    ],
  },
  cta: {
    title: "Samly'ni oʻz menyuingizda koʻrsatamiz",
    subtitle: "Birinchi oy bepul, toʻliq toʻplam · Sozlashni jamoamiz bajaradi",
    note: "Onboarding bepul. Uskuna alohida sotib olinadi — tanlashda yordam beramiz.",
    cta_primary: "Bogʻlanish",
    cta_secondary: "Qoʻngʻiroq qilish",
    trust_payment: "Click · Payme · Rahmat",
    trust_support: "Haftada 6 kun qoʻllab-quvvatlash",
    trust_local: "Oʻzbekiston uchun yaratilgan",
  },
  footer: {
    description:
      "Butun muassasa uchun bitta menyu va bitta ombor: kassa, oʻz yetkazib berish, QR menyu, ofitsiant, ekranlar va ombor.",
    product: "Mahsulot",
    support: "Qoʻllab-quvvatlash",
    contacts: "Kontaktlar",
    copyright: "Barcha huquqlar himoyalangan.",
    lang_label: "Til",
    links: {
      features: "Imkoniyatlar",
      pricing: "Narx",
      integrations: "Integratsiyalar",
      modules: "Nima kiradi",
      apps: "Ilovalar",
      faq: "Savol-javob",
      contact: "Bogʻlanish",
      telegram: "Telegram",
    },
  },
  contact: {
    title: "Muassasangizni muhokama qilamiz",
    subtitle: "Qoʻngʻiroq qiling yoki yozing — Samly'ni koʻrsatamiz va birga sozlab beramiz.",
    call: "Qoʻngʻiroq qilish",
    telegram_label: "Telegram",
    instagram_label: "Instagram",
    hours_label: "Ish vaqti",
    hours: "Dushanba–Shanba, 10:00–22:00",
    trust: "Birinchi oy bepul · Sozlashni jamoamiz bajaradi",
  },
  modal: {
    title: "Samly'ni bepul sinab koʻring",
    subtitle: "Ariza qoldiring — menejer ish vaqtida bogʻlanadi",
    name_placeholder: "Ismingiz",
    phone_placeholder: "Telefon raqami",
    submit: "Ariza yuborish",
    submitting: "Yuborilmoqda...",
    success_title: "Ariza qabul qilindi!",
    success_desc: "Menejer ish vaqtida siz bilan bogʻlanadi",
    error_required: "Majburiy maydon",
    error_name_min: "Kamida 2 ta belgi",
    error_phone: "Toʻgʻri telefon raqamini kiriting",
    error_server: "Xato. Qaytadan urinib koʻring",
    toast_error_title: "Yuborib boʻlmadi",
  },
  apps: {
    title: "Ilovalarimiz",
    subtitle: "Kassa — kompyuterga, egasi va ofitsiant ilovalari — telefonga.",
    pos: {
      title: "Windows uchun Samly kassasi",
      desc: "Kassadagi kompyuter uchun dastur: buyurtmalar, toʻlov, chek chop etish.",
      button: "Windows uchun yuklab olish",
      mobileHint: "Kassa kompyuteriga oʻrnating",
    },
    owner: { title: "Egasi uchun ilova", desc: "Barcha muassasalar boʻyicha tushum, smenalar va hisobotlar telefoningizda." },
    waiter: { title: "Ofitsiant ilovasi", desc: "Stol yonida buyurtma qabul qilish va oshxonaga yuborish." },
    soon: "Tez kunda",
    downloadOn: "Yuklab oling:",
    getItOn: "Mavjud:",
  },
  installGuide: {
    title: "Kassani qanday oʻrnatish kerak",
    subtitle: "Yuklab olish boshlandi. Windows ogohlantirish koʻrsatsa — bu odatiy hol, quyidagi qadamlarni bajaring.",
    subtitleHash: "Oʻrnatuvchini quyidagi tugma orqali yuklab oling va qadamlarni bajaring. Windows ogohlantirish koʻrsatsa — bu odatiy hol.",
    steps: {
      browser: {
        title: "Faylni saqlang",
        text: "Brauzer bu fayl kam yuklab olinishini yozishi mumkin. «Сохранить» tugmasini bosing. Edge’da: «…» → «Сохранить» → «Показать больше» → «Всё равно сохранить».",
      },
      smartscreen: {
        title: "Oʻrnatuvchini oching",
        text: "Yuklab olingan faylni ishga tushiring. Windows «Windows защитила ваш компьютер» oynasini koʻrsatadi. «Подробнее» tugmasini bosing.",
      },
      runAnyway: {
        title: "Ishga tushirishga ruxsat bering",
        text: "«Выполнить в любом случае» tugmasi paydo boʻladi. Uni bosing. Bu oyna oʻrnatuvchida hozircha raqamli imzo yoʻqligi sababli chiqadi.",
      },
      installer: {
        title: "Kassani oʻrnating",
        text: "Windows ilovaga oʻzgartirish kiritishga ruxsat soʻraydi — «Да» tugmasini bosing. Oʻrnatish oynasidagi qadamlarni oxirigacha bajaring. Ish stolida Samly POS yorligʻi paydo boʻladi.",
      },
      connect: {
        title: "Kassani ulang",
        text: "Samly POS’ni oching va ulanish kodini kiriting. Kod bek-ofisda: Filial sozlamalari → Qurilmalar.",
      },
    },
    retry: "Yuklab olish boshlanmadimi?",
    retryLink: "Qayta yuklab olish",
    help: "Oʻrnatib boʻlmayaptimi? Telegram’da bizga yozing",
    close: "Tushunarli",
  },
};
